import React from "react";
import {TaggedLogger} from "@nextlot/core/src/utilities";
import NextLotJSDATA from "@nextlot/core/src/NextLotJSDATA";

const _logger = TaggedLogger.get('useViewerSignupReminderToggle');


export default function useViewerSignupReminderToggle(): [boolean, ()=>void] {
  const timeoutIdRef = React.useRef<number | null>(null);

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const modal_onRequestClose = () => {
      setIsModalOpen(false);
      startViewerSignupReminder();
  };

  const modal_Open = () => {
      timeoutIdRef.current !== null && clearTimeout(timeoutIdRef.current);
      setIsModalOpen(true);
  }

  const startViewerSignupReminder = () => {
    if(NextLotJSDATA.webcast_viewer_signup_reminder_enabled) {
        timeoutIdRef.current = window.setTimeout(modal_Open, NextLotJSDATA.webcast_viewer_signup_reminder_minutes * 60_000);
    }
  }

  React.useEffect(() => {
      startViewerSignupReminder();

      return () => {
        timeoutIdRef.current !== null && clearTimeout(timeoutIdRef.current);
      };
  }, [])


  return [isModalOpen, modal_onRequestClose];
}
